jQuery(function ($) {

  const $drawer = $('.es-drawer');

  /* ===============================
     OPEN / CLOSE DRAWER
  =============================== */
  $('.es-menu-toggle').on('click', function () {
    $('.es-drawer, .es-overlay').addClass('active');
    $('body').addClass('menu-open');
  });

  $('.es-close, .es-overlay').on('click', function () {
    $('.es-drawer, .es-overlay').removeClass('active');
    $('body').removeClass('menu-open');

    // reset nav
    $('.slide-nav__dropdown').removeClass('active');
    $('.slide-nav').removeClass('submenu-open');
  });

  /* ===============================
     OPEN SUBMENU (LEVEL 1,2,3)
  =============================== */
  $drawer.on('click', '.js-toggle-submenu', function (e) {
    e.preventDefault();

    const target = $(this).data('target');

    if (!target) return;

    const $submenu = $('.slide-nav__dropdown[data-parent="' + target + '"]');

    if (!$submenu.length) return;

    // close current level
    $('.slide-nav__dropdown.active').removeClass('active');

    // open target
    $submenu.addClass('active');
    $('.slide-nav').addClass('submenu-open');
  });

  /* ===============================
     BACK BUTTON
  =============================== */
  $drawer.on('click', '.slide-nav__return-btn', function (e) {
    e.preventDefault();

    const parentTarget = $(this).data('target');

    // Close all
    $('.slide-nav__dropdown').removeClass('active');

    // If returning to a parent submenu
    if (parentTarget) {
      $('.slide-nav__dropdown[data-parent="' + parentTarget + '"]').addClass('active');
    } else {
      $('.slide-nav').removeClass('submenu-open');
    }
  });

});



jQuery(function ($) {

  var $menuToggle = $('.es-menu-toggle');
  var $slideNav   = $('.slide-nav');
  var $overlay    = $('.es-overlay');

  if (!$menuToggle.length || !$slideNav.length) return;

  /* OPEN MENU */
  $menuToggle.on('click', function (e) {
    e.preventDefault();

    $slideNav.addClass('es-active');
    $overlay.addClass('active');
    $('body').addClass('es-menu-open');
  });

  /* CLOSE MENU */
  function closeMenu() {
    $slideNav.removeClass('es-active');
    $overlay.removeClass('active');
    $('body').removeClass('es-menu-open');
  }

  $overlay.on('click', closeMenu);

  /* Close when clicking any slide-nav return button */
  $(document).on('click', '.slide-nav__return-btn', function () {
    // this keeps existing submenu logic intact
  });

});
